class ProjectsSection extends HTMLElement {
  constructor() {
    super();
    this.activeTag = '';
    this.query = '';
    this.onPillClick = this.onPillClick.bind(this);
    this.onSearchInput = this.onSearchInput.bind(this);
  }

  connectedCallback() {
    this.pills = this.querySelectorAll('[data-projects-pill]');
    this.items = this.querySelectorAll('[data-projects-item]');
    this.searchInput = this.querySelector('[data-projects-search]');
    this.emptyState = this.querySelector('[data-projects-empty]');

    this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick));
    if (this.searchInput) {
      this.searchInput.addEventListener('input', this.onSearchInput);
    }

    const params = new URLSearchParams(window.location.search);
    const initialTag = params.get('project_tag') || '';
    this.setTag(initialTag);
  }

  disconnectedCallback() {
    this.pills.forEach((pill) => pill.removeEventListener('click', this.onPillClick));
    if (this.searchInput) {
      this.searchInput.removeEventListener('input', this.onSearchInput);
    }
  }

  onPillClick(event) {
    const tag = event.currentTarget.getAttribute('data-projects-pill') || '';
    // "All" always clears; other pills toggle off if clicked again
    if (tag === '') {
      this.setTag('');
      return;
    }
    this.setTag(tag === this.activeTag ? '' : tag);
  }

  onSearchInput(event) {
    this.query = (event.target.value || '').trim().toLowerCase();
    this.filter();
  }

  setTag(tag) {
    this.activeTag = tag || '';
    this.syncActiveState();
    this.filter();
    this.syncUrl();
  }

  syncActiveState() {
    this.pills.forEach((pill) => {
      const value = pill.getAttribute('data-projects-pill') || '';
      const isActive = value === this.activeTag;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  syncUrl() {
    try {
      const url = new URL(window.location.href);
      if (this.activeTag) {
        url.searchParams.set('project_tag', this.activeTag);
      } else {
        url.searchParams.delete('project_tag');
      }
      window.history.replaceState({}, '', url);
    } catch (error) {
      // Ignore URL sync errors in theme editor / sandboxed previews.
    }
  }

  filter() {
    let visibleCount = 0;

    this.items.forEach((item) => {
      const tag = (item.getAttribute('data-tag') || '').trim().toLowerCase();
      const haystack = (item.getAttribute('data-search') || item.getAttribute('data-title') || '')
        .trim()
        .toLowerCase();
      const activeTag = this.activeTag.trim().toLowerCase();

      const matchesTag = !activeTag || tag === activeTag;
      const matchesQuery = !this.query || haystack.includes(this.query);
      const isVisible = matchesTag && matchesQuery;

      item.classList.toggle('is-hidden', !isVisible);
      if (isVisible) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.classList.toggle('is-visible', visibleCount === 0);
    }
  }
}

customElements.define('projects-section', ProjectsSection);
